<template>
  <div class="job-wrap">
    <div class="content">
      <el-form :model="jobInfo" :rules="rules" ref="job">
        <el-form-item label="岗位名称" prop="job_name">
          <el-input placeholder="请输入岗位名称" v-model="jobInfo.job_name"></el-input>
        </el-form-item>
        <el-form-item label="岗位类型" prop="job_type">
          <el-select v-model="jobInfo.job_type" placeholder="选择岗位类型" style="width: 100%">
            <el-option v-for="item in jobTypes" :key="item.id" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="salary">
          <div>
            <span class="red">*</span> 薪资
          </div>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-select v-model="jobInfo.salary_start" placeholder="最低薪资" style="width: 100%;">
                <el-option v-for="item in $store.state.salaryList" :key="item.id" :label="item.value"
                  :value="item.value"></el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-select v-model="jobInfo.salary_end" placeholder="最高薪资" style="width: 100%;">
                <el-option v-for="item in $store.state.salaryList" :key="item.id" :label="item.value"
                  :value="item.value"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="招聘人数" prop="recruitment">
              <el-input placeholder="请输入人数" v-model="jobInfo.recruitment"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="食宿安排">
              <el-select v-model="jobInfo.food_bed" placeholder="选择食宿安排" style="width: 100%">
                <el-option v-for="item in $store.state.foodBedList" :key="item.id" :label="item.value"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="年龄要求">
              <el-select v-model="jobInfo.age_require" placeholder="选择年龄要求">
                <el-option label="不限" value="不限"></el-option>
                <el-option label="18岁以上" value="18岁以上"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学历要求">
              <el-select v-model="jobInfo.education" placeholder="选择学历要求">
                <el-option v-for="item in educations" :key="item.id" :label="item.value" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="city_id">
          <div>
            <span style="color: red;">*</span>工作城市
          </div>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-select placeholder="省" v-model="jobInfo.province_id" @change="provChange" style="width: 100%;">
                <el-option v-for="item in $store.state.provinces" :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-select placeholder="市" v-model="jobInfo.city_id" ref="city" style="width: 100%;">
                <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="工作地点" prop="job_address">
          <el-input placeholder="请输入工作地点" v-model="jobInfo.job_address"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contact">
          <el-input v-model="jobInfo.contact" placeholder="请填写联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="telephone">
          <el-input v-model="jobInfo.telephone" placeholder="请填写联系电话"></el-input>
        </el-form-item>
        <!-- <el-form-item label="岗位诱惑">
          <el-input placeholder="请输入岗位诱惑" v-model="jobInfo.job_attraction"></el-input>
        </el-form-item> -->
        <el-form-item prop="job_detail">
          <!-- <el-input
            type="textarea"
            :autosize="{minRows: 2}"
            placeholder="请输入岗位描述"
            v-model="jobInfo.job_detail"
          ></el-input>-->
          <div>
            <span style="color: red;">*</span> 岗位描述
          </div>
          <div id="wangeditor">
            <div ref="editorElem" style="text-align:left;"></div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="截止时间">
          <el-date-picker v-model="jobInfo.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择截止时间"
            style="width: 100%;" :editable="false"></el-date-picker>
        </el-form-item> -->
        <button class="next" @click.prevent="submitForm('job')">下一步</button>
      </el-form>
    </div>
  </div>
</template>

<script>
import formatter from "@/assets/js/mixins/formatter";
import E from "wangeditor";

export default {
  mixins: [formatter],
  data() {
    let checkProvAndCity = (rule, value, callback) => {
      if (!value) {
        callback(new Error("省市必填"));
      } else if (!this.$refs.city.value) {
        callback(new Error("市级必填"));
      } else {
        callback();
      }
    };
    return {
      jobInfo: {
        job_name: null,
        job_type: null,
        salary_start: "",
        salary_end: "",
        salary: null,
        recruitment: 1,
        food_bed: null,
        age_require: null,
        education: null,
        province_id: "",
        city_id: "",
        province: null,
        city: null,
        job_address: null,
        job_attraction: null,
        job_detail: null,
        contact: null,
        telephone: null,
        end_time: null,
        school_id: this.$route.query.schoolId,
        inviter_id: this.$route.query.studentId || this.$route.query.schoolId
      },
      rules: {
        job_name: [
          {
            required: true,
            message: "请输入岗位名称",
            trigger: "blur"
          }
        ],
        city_id: [
          {
            required: true,
            validator: checkProvAndCity,
            trigger: ["blur", "change"]
          }
        ],
        job_detail: [
          {
            required: true,
            message: "请输入岗位描述",
            trigger: "blur"
          }
        ],
        request: [
          {
            required: true,
            message: "请输入岗位要求",
            trigger: "blur"
          }
        ],
        recruitment: [
          {
            required: true,
            message: "请输入招聘人数",
            trigger: "blur"
          }
        ],
        salary: [
          {
            required: true,
            message: "请输入岗位待遇",
            trigger: "blur"
          }
        ],
        job_type: [
          {
            required: true,
            message: "请输入食宿安排",
            trigger: "blur"
          }
        ],
        job_address: [
          {
            required: true,
            message: "请输入工作地点",
            trigger: "blur"
          }
        ],
        contact: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur"
          }
        ],
        telephone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur"
          }
        ]
      },
      cityList: [],
      jobTypes: [],
      educations: []
    };
  },
  mounted() {
    // console.log(this.$store.state.salaryList)
    this.getJobTypes();
    this.getEducations();
    this.initRichText();
  },
  watch: {
    "jobInfo.recruitment"(newVal) {
      if (!/^[1-9]\d*$/.test(newVal)) {
        this.$message.error("请输入纯数字！");
        this.jobInfo.recruitment = "";
      }
    },
    "jobInfo.salary_start"(val) {
      if (val) {
        if (this.jobInfo.salary_end) {
          this.jobInfo.salary = `${val} ~ ${this.jobInfo.salary_end}`;
        } else {
          this.jobInfo.salary = `${val}`;
        }
      }
    },
    "jobInfo.salary_end"(val) {
      if (val && this.jobInfo.salary_start) {
        this.jobInfo.salary = `${this.jobInfo.salary_start} ~ ${val}`;
      }
    },
    "jobInfo.province_id"(val) {
      if (val) {
        this.jobInfo.province = this.formatProv(val);
      }
    },
    "jobInfo.city_id"(val) {
      if (val) {
        this.jobInfo.city = this.formatCity(this.cityList, val);
      }
    }
  },
  methods: {
    initRichText() {
      // 富文本
      this.editor = new E(this.$refs.editorElem);
      // 编辑器的事件，每次改变会获取其html内容
      this.editor.customConfig.onchange = html => {
        this.jobInfo.job_detail = html;
      };
      this.editor.customConfig.menus = [
        // 菜单配置
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough" // 删除线
        // "foreColor", // 文字颜色
        // "backColor", // 背景颜色
        // "link", // 插入链接
        // "list", // 列表
        // "justify", // 对齐方式
        // "quote", // 引用
        // "emoticon", // 表情
        // "image", // 插入图片
        // "table", // 表格
        // "code", // 插入代码
        // "undo", // 撤销
        // "redo" // 重复
      ];
      this.editor.create(); // 创建富文本实例
    },
    async getJobTypes() {
      let type = await this.$api.common.getJobType();
      if (type.code === 0) {
        this.jobTypes = type.data;
      }
    },
    async getEducations() {
      let education = await this.$api.common.getEducationList();
      if (education.code === 0) {
        this.educations = education.data;
      }
    },

    async getXixunCity(provinceId) {
      let res = await this.$api.common.getXixunCity(provinceId);
      // console.log(res.data);
      if (res.code === 0) {
        this.cityList = res.data;
      }
    },
    provChange(provId) {
      this.cityList = null;
      this.jobInfo.city_id = null;
      this.getXixunCity(provId);
    },
    submitForm(formName) {
      // this.jobInfo.job_detail = this.editor.txt.text();
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addInfo();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async addInfo() {
      let res = null;
      if (this.jobInfo.salary.indexOf("面议") == -1) {
        if (parseInt(this.jobInfo.salary_start.substring(0, this.jobInfo.salary_start.length - 1)) > parseInt(this.jobInfo.salary_end.substring(0, this.jobInfo.salary_end.length - 1))) {
          this.$message({
            message: "最低薪资不能大于最高薪资!",
            type: "warning",
            center: true
          });
          return;
        }
      }
      let params = this.delNullVal(this.jobInfo);
      params.source = this.$route.query.register_source
      res = await this.$api.job.addInternshipJob(params);
      if (res.code === 0) {
        this.$message({
          message:
            "岗位发布成功，请电脑登录qxiaoyun.com，查看学生投递和岗位发布状态",
          type: "success",
          center: true,
          duration: 10000
        });

        // 获取需要付费的学校Id
        let res2 = await this.$api.school.getPaySchoolIds();
        let res3 = await this.$api.info.get();
        let pathUrl = "success";

        if (res2.code == 0 && res3.code == 0) {
          if (res3.data[0].pay_status == "no_paid") {
            res2.data.forEach(item => {
              if (item.school_id == this.$route.query.schoolId) {
                pathUrl = "enterprise-pay-h5";
                return;
              }
            });
          }
        }
        this.$router.push({
          path: pathUrl,
          query: {
            relationId: this.$route.query.relationId,
            schoolId: this.$route.query.schoolId
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scope>
@import "~@/assets/css/base.scss";

.job-wrap {
  background: url("~@/assets/img/bg.png") no-repeat;
  background-size: 100% 500px;
  padding: 20px 16px 26px;

  .content {
    background: #fff;
    border-radius: 12px;
    padding: 10px 15px 0 5px;

    .el-form-item {
      margin-bottom: 10px;
    }

    .el-form-item__label {
      line-height: 30px;
    }

    .el-row {
      margin-bottom: 0;
    }

    .next {
      width: 100%;
      height: vw(67);
      text-align: center;
      line-height: vw(67);
      border-radius: vw(33);
      background: #66aef4;
      color: #fff;
      font-size: vw(28);
      border: none;
      outline: none;
      margin-top: 40px;
    }
  }
}

@media screen and (min-width: 500px) {
  .job-wrap {
    .content {
      width: 400px;
      margin: 0 auto;

      .next {
        height: 50px;
        line-height: 50px;
        font-size: 18px;
      }
    }
  }
}
</style>
<style>
.el-picker-panel {
  z-index: 10000 !important;
}

.w-e-menu {
  z-index: 15 !important;
}

/* .w-e-toolbar .w-e-menu {
  z-index: 15 !important;
} */
.w-e-text-container {
  position: relative;
  z-index: 10 !important;
}
</style>